"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkUserLoggedIn = exports.getHubScopes = exports.getAuth = void 0;

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _Raven = _interopRequireDefault(require("Raven"));

var ActionTypes = _interopRequireWildcard(require("./ActionTypes"));

var _hubsClient = require("../clients/hubsClient");

var getAuth = function getAuth() {
  return function (dispatch) {
    _PortalIdParser.default.get();

    return (0, _userInfo.default)().then(function (_ref) {
      var user = _ref.user,
          gates = _ref.gates,
          portal = _ref.portal;

      _Raven.default.setUserContext({
        id: user.user_id,
        email: user.email,
        locale: user.locale
      });

      dispatch({
        type: ActionTypes.INITIALIZE_AUTH,
        user: user,
        gates: gates,
        portal: portal
      });
    });
  };
};

exports.getAuth = getAuth;

var getHubScopes = function getHubScopes() {
  return function (dispatch) {
    dispatch({
      type: ActionTypes.HUB_FETCH_REQUESTED
    });
    return (0, _hubsClient.getHub)().then(function (_ref2) {
      var scopes = _ref2.scopeLimitInfo.scopes;
      dispatch({
        type: ActionTypes.HUB_FETCH_RECEIVED,
        payload: scopes
      });
    }).catch(function (err) {
      dispatch({
        type: ActionTypes.HUB_FETCH_FAILED,
        payload: err
      });
    });
  };
}; // TODO move to early requester?


exports.getHubScopes = getHubScopes;

var checkUserLoggedIn = function checkUserLoggedIn() {
  return function (dispatch) {
    dispatch({
      type: ActionTypes.LOGIN_VERIFY_CHECKED
    });
    return _noAuthApiClient.default.get('/login-verify/echo/user', {
      timeout: 2000
    }).then(function (resp) {
      var _window$location = window.location,
          hostname = _window$location.hostname,
          pathname = _window$location.pathname,
          search = _window$location.search;

      if (resp.email.includes('@hubspot.com') && !search.includes('_redirect=true')) {
        // Turn off public redirect for internal hubspotters. Useful for
        // sales and customer success teams who don't always want the in-app version
        return;
      }

      var IS_QA = hostname.indexOf('hubspotqa') !== -1;
      var APP_DOMAIN = IS_QA ? 'app.hubspotqa.com' : 'app.hubspot.com'; // Most query params are NOT preserved through short links, so we dont pass window.location.search here.

      var redirectUrl = "https://" + APP_DOMAIN + "/l/ecosystem/" + pathname + search; // Use redirect so we dont keep the public page in history

      window.location.replace(redirectUrl);
    }).catch(function () {// Public, not logged-in user, we don't have to do anything
    });
  };
};

exports.checkUserLoggedIn = checkUserLoggedIn;


//////////////////
// WEBPACK FOOTER
// ./js/actions/AuthActions.js
// module id = 920
// module chunks = 192 210 211 212